<template>
  <div class="grm-slider-component">
    <input
      ref="input"
      type="range"
      class="grm-slider"
      :style="inputStyle"
      :min="min"
      :max="max"
      :step="step"
      :value="value"
      @touchstart="onEvent"
      @touchend="onEvent"
      @pointerdown="onEvent"
      @pointerup="onEvent"
      @mousedown="onEvent"
      @mouseup="onEvent"
      @input="onEvent"
      @change="onEvent"
    />
  </div>
</template>

<script>
export default {
  name: 'GrmSlider',
  props: {
    min: { type: [String, Number], default: 0 },
    max: { type: [String, Number], default: 100 },
    step: { type: [String, Number], default: 1 },
    value: { type: [String, Number], default: 100 },
  },
  computed: {
    inputStyle() {
      const val = this.value / this.max * 100
      return {
        background: 'linear-gradient(to right, #09f 0%, #09f '+ val +'%, #fff ' + val + '%, #fff 100%)',
      }
    },
  },
  methods: {
    onEvent(e) {
      this.$emit(e.type, e)
    }
  }
}
</script>

<style lang="scss" scoped>
.grm-slider-component {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.grm-slider {
  width: 100%;
  height: 2px;
  border-radius: 10px;
  background-color: #fff;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  -webkit-appearance: none;
  &::-webkit-slider-runnable-track {
    height: 10px;
    color: #09f;
    transition: 0.2s ease-in-out;
    -webkit-appearance: none;
  }
  &::-webkit-slider-thumb {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: #fff;
    transition: 0.2s ease-in-out;
    -webkit-appearance: none;
  }
  &:hover {
    height: 8px;
    &::-webkit-slider-runnable-track {
      margin-top: -6px;
    }
    &::-webkit-slider-thumb {
      width: 16px;
      height: 16px;
      background: #09f;
    }
  }
}
</style>
